module.exports = __webpack_public_path__ + "img/en.39195acc.svg";